import DOMPurify, { Config } from 'dompurify';

export const sanitizeHTML = (html: string, options: Config) => {
  const sanitized = DOMPurify.sanitize(html, options).toString();
  return { __html: sanitized };
};
